export const SUCCESS_POPUP_TYPE = {
  CLAIMED_VIR: 'claimed-vir',
  CLAIMED_QBX: 'claimed-qbx'
}
